<template>
  <div>
    <b-button
      variant="success"
      @click="create"
    >
      New Book
    </b-button>
    <br><br>
    <Search
      route="/books"
      placeholder="Find book by id (exact match)"
    />
    <DataTable
      id="id"
      api="/admin/books"
      id-url="/books/"
      :status-variants="statusVariants"
    />
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import Search from '@core/components/search/Search.vue'

import {
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    DataTable,
    BButton,
    Search,
  },
  data() {
    return {
      // live everywhere, live on the web store only, not live yet, removed but kept for owners
      statusVariants: {
        NORMAL: 'success',
        WEBSPECIAL: 'info',
        HIDDEN: 'warning',
        DELETED: 'secondary',
      },
    }
  },
  methods: {
    create() {
      this.$router.push('/books/add')
    },
  },
}
</script>
